export default __webpack_public_path__ + "static/media/member-map.d24a1495.png";